



// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Constants
import Assets from '@/constants/assets.ts';
import Endpoints from '@/constants/endpoints';

// Components
import Btn, { BtnColor, BtnWidth, BtnHeight, BtnFontSize, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';

// Models
import { Budget } from '@/manager/budget/models/budget.model';

// Views
import InfoView from '@/shared/views/info.view.vue';


@Component({
    components: {
        Btn,
        Icon,
        InfoView,
    },
})
export default class MandateActions extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop() private id!: string;


    private assets = Assets;
    private iconEnum = IconEnum;
    private btnColor = BtnColor;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private btnFontSize = BtnFontSize;
    private btnWidth = BtnWidth;
    private btnHeight = BtnHeight;
    private literals = {
        title: 'Mandato SEPA',
        previewBtn: 'Previsualizar SEPA',
        signBtn: 'Firmar documento',
    };


    get backgroundImage() {
        return {
            'background-image': `url("${this.assets.sepaPreview}")`,
            'background-repeat': 'no-repeat',
            'background-position-x': 'left',
            'background-position-y': 'top',
            'background-size': 'cover',
        };
    }


    private previewPdf() {
        const url = Endpoints.mandateDocument(this.id);
        window.open(url, '_blank');
    }

    private setOpenSignModal(value: boolean) {
        this.$emit('open-sign-modal', value);
    }

    private signDocument() {
        this.setOpenSignModal(true);
    }
}
